import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSunset: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSunset"><Path d="M6.5 20.5H17.5M1.5 16.5H22.5M3.5 12.5C3.5 7.52944 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.52944 20.5 12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSunset;
